import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { Box, MenuItem, Select, Typography, type SelectChangeEvent } from '@mui/material'
import { color } from 'config/color'
import { useAuth } from 'context'
import { useEffect, useMemo, useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

export interface ServiceAddressType {
    legacyAcctNumber: string
    premiseId: string
    serviceAddress: string
    accountId: string

}

export const ServiceAddress: React.FC = () => {
    const { account, propManAccount, handleCurrentAccount } = useAuth()
    const [serviceAddresses, setServiceAddresses] = useState<ServiceAddressType[]>([])
    const [selectedAddress, setSelectedAddress] = useState<ServiceAddressType>({
        legacyAcctNumber: '',
        premiseId: '',
        serviceAddress: '',
        accountId: ''
    })
    const isMobile = useMobileBreakpoints()
    const [isOpen, setIsOpen] = useState(false)

    const addresses = useMemo(() => {
        return propManAccount?.myAccount?.serviceAddresses ?? account?.myAccount?.serviceAddresses
    }, [account, propManAccount])

    const uniqueServiceAddresses = useMemo(() => {
        const getUniqueServiceAddresses = (addresses: ServiceAddressType[]) => {
            return addresses.filter(
                (value, index, self) =>
                    self.findIndex((v) => v.accountId === value.accountId) === index
            )
        }

        return addresses ? getUniqueServiceAddresses(addresses) : []
    }, [addresses])

    useEffect(() => {
        if (uniqueServiceAddresses.length > 0) {
            setServiceAddresses(uniqueServiceAddresses)
            setSelectedAddress(uniqueServiceAddresses[0])
        }
    }, [uniqueServiceAddresses])


    const handleChange = async (e: SelectChangeEvent): Promise<void> => {
        const tempAddress = serviceAddresses.find((address) => address.accountId === (e.target.value))
            ; (tempAddress != null) && setSelectedAddress(tempAddress)
        handleCurrentAccount({ accountId: tempAddress?.accountId ?? '', premiseId: tempAddress?.premiseId ?? '' })
    }


    return (
        <> {
            isMobile
                ? <Box display="flex" flexDirection="column">
                    <Typography color={color.grey[700]} fontSize={12}>Service Addresss</Typography>
                    <Select variant="standard" value={selectedAddress?.accountId} onOpen={() => { setIsOpen(true) }} onClose={() => { setIsOpen(false) }} onChange={handleChange} disableUnderline={true} sx={{ fontSize: '16px' }} IconComponent={() => isOpen ? <ExpandLessIcon sx={{ color: color.primary[500] }} /> : <ExpandMoreIcon sx={{ color: color.primary[500] }} />}>
                        {serviceAddresses.length === 0 && (
                            <MenuItem value="">No active accounts</MenuItem>
                        )}
                        {serviceAddresses.length !== 0 && serviceAddresses.map((address: ServiceAddressType, index) => {
                            return (
                                <MenuItem key={index} value={address.accountId}>
                                    <Typography fontSize={14} textTransform="uppercase" noWrap>
                                        {`${address.serviceAddress?.toLowerCase()?.split(',')[0] ?? ''} | ${address.accountId}`}
                                    </Typography>
                                </MenuItem>
                            )
                        })}
                    </Select>
                </Box >
                : <Select
                    onOpen={() => { setIsOpen(true) }} onClose={() => { setIsOpen(false) }}
                    fullWidth
                    sx={{
                        fontSize: '14px',
                        color: color.white,
                        border: `solid 1px ${color.primary[800]}`,
                        borderRadius: '0px 0px 2px 2px'
                    }}
                    value={selectedAddress?.accountId}
                    onChange={handleChange}
                    IconComponent={() => isOpen ? <ExpandLessIcon sx={{ color: color.primary[500] }} /> : <ExpandMoreIcon sx={{ color: color.primary[500] }} />}
                >
                    {serviceAddresses.length === 0 && (
                        <MenuItem value="">No active accounts</MenuItem>
                    )}
                    {serviceAddresses.length !== 0 && serviceAddresses.map((address: ServiceAddressType, index) => {
                        return (
                            <MenuItem key={index} value={address.accountId}>
                                <Typography fontSize={14} textTransform="uppercase" noWrap>
                                    {`${address.serviceAddress} | ${address.accountId}`}
                                </Typography>
                            </MenuItem>
                        )
                    })}
                </Select>
        }
        </>
    )
}
